import React from "react";

import format from "date-fns/format";

import { NO_DATA_FOUND } from "../../../constants";

const EarningReportsList = ({
  earningReports,
  searchValue,
  searchEarningReports,
  searchData
}) => {

  let fetchedEarningReports = earningReports
  if (searchEarningReports?.length!=0){
    fetchedEarningReports=searchEarningReports
  }
  else{
    fetchedEarningReports=earningReports
  }

  const CategoryChoices = {
    SUBSCRIPTION: "Subscription",
    APPOINTMENT: "Appointment",
    PERSONALISE_THEME: "Personalise Theme",
    VISIT_NOW: "Visit Now",
    CALL_STARTED: "Call Started",
    NO_SHOW_FEES: "No Show Fees",
    LATE_CANCELLATION_FEES: "Late Cancellation Fees",
    LATE_RESCHEDULE_FEES: "Late Reschedule Fees",
    APPOINTMENT_CHARGE: "Appointment Charge",
    CONCIERGE_SERVICE_SUBSCRIPTION: "Concierge Service Fee",
    NEW_SUBSCRIPTION_REQUEST: "Concierge Service Fee",
    PATIENT_SUBSCRIPTION_RENEW: "Renew Concierge Service Subscription"
  };

  const handleConvertCategory = (category) => {
    return CategoryChoices[category]
  };
 
  

  return (
    <>
      {fetchedEarningReports?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="blocked">
          <table class="table mt-3">
            <thead>
              <tr>
                <th className="col-4">Patient Name</th>
                <th className="col-2">Date</th>
                <th className="col-2">Category</th>
                <th className="col-1">Fees</th>
              </tr>
            </thead>
            <tbody>
              {fetchedEarningReports &&
                fetchedEarningReports?.map((report, index) => {
                  return (
                    <tr key={report.id}>
                      <td>
                        <span>
                          {report?.first_name} {report?.last_name}{" "}
                        </span>
                      </td>
                      <td className="">
                        {" "}
                        {format(
                          new Date(report?.created_at || new Date()),
                          "MMMM dd, yyyy"
                        )}
                      </td>
                      <td>
                        {CategoryChoices[report?.category]}
                      </td>
                      <td
                        className="mr-auto payment-amount "
                        style={{ cursor: "pointer" }}
                      >
                        ${report?.amount}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default EarningReportsList;
